import React, { useContext, useEffect, useState } from 'react';
import PageTitle from '../../../../jsx/layouts/PageTitle';
import ReactPaginate from 'react-paginate';
import { AccountManagementContext } from '../../../../context/AccountManagementContext';
import { useParams } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { RiDeleteBinLine } from 'react-icons/ri';
import { useDeleteHandler } from '../../../../hooks/useDeleteHandler';
import { DeleteAssignUser } from '../../../../services/adminApiService/accountManagementApi/AccountManagementApiService';
const AssignUserList = ({ }) => {
    const { id } = useParams();

    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const { loading, fetchAssignRoleList, assignUserList, fetchRoleAccountManagementList } = useContext(AccountManagementContext);

    const { handleDelete } = useDeleteHandler();
    const handlePageChange = (event) => {
        // Adjusting for zero-based index by adding 1
        const selectedPage = event.selected + 1;
        setCurrentPage(selectedPage);
    };
    const deleteHandler = (assignUserId) => {
        handleDelete({
            deleteApi: () => DeleteAssignUser(id, assignUserId),
            id,
            refreshListApi: () => {
                fetchAssignRoleList(id);
                fetchRoleAccountManagementList(
                    "",
                    "desc",
                    "",
                    perPage,
                    currentPage);
            },
            successMsg: "Assigned Role deleted successfully",
            redirectPath: "/account/role",
        });
    };
    useEffect(() => {
        fetchAssignRoleList(id);
    }, [fetchAssignRoleList]);
    return (
        <>
            <PageTitle activeMenu="User Assigned" motherMenu="Roles" />
            <Card>
                <div className="mx-5 py-4">

                    <div className="d-flex">
                        <h4 className="mt-1">Role :</h4>
                        <p className="px-2 mt-1">{assignUserList?.data?.data?.role_name || assignUserList?.data?.role_name || "N/A"}</p>
                    </div>

                    <div className="d-flex">
                        <h4 className="mt-1" style={{ minWidth: "120px" }}>Description :</h4>
                        <p className="px-2 mt-1 mb-0">
                            {assignUserList?.data?.data?.description || assignUserList?.data?.description || "N/A"}
                        </p>
                    </div>
                </div>


            </Card>
            <Card>
                <div className="card-body">
                    {loading ? (
                        <div className="text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="w-100 table-responsive">
                            <div id="example_wrapper" className="dataTables_wrapper">
                                <table id="example" className="display w-100 dataTable">
                                    <thead>
                                        <tr>
                                            {/*<th>SN</th>*/}
                                            <th

                                            >
                                                ID

                                            </th>
                                            <th>Full Name</th>
                                            <th>Email</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {((assignUserList?.data?.data?.assigned_users?.length > 0) || (assignUserList?.data?.assigned_users?.length > 0)) ? (
                                            (assignUserList?.data?.data?.assigned_users || assignUserList?.data?.assigned_users || []).map((data, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{data?.name}</td>

                                                        <td>{data?.email}</td>


                                                        <td
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            <div className="d-flex ">
                                                                <div className="icon_wrapper mx-2 " onClick={() => deleteHandler(data?.id)}><RiDeleteBinLine className="text-danger" /></div>
                                                            </div>

                                                        </td>

                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="9" className="text-center">
                                                    Data is not available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </Card>


            {/* Pagination removed - details API returns all users without pagination */}
            {((assignUserList?.data?.data?.assigned_users?.length || assignUserList?.data?.assigned_users?.length || 0) > 0) && (
                <div className="text-center mt-3">
                    <p className="text-muted">
                        Total Users: {assignUserList?.data?.data?.assigned_users?.length || assignUserList?.data?.assigned_users?.length || 0}
                    </p>
                </div>
            )}


        </>
    );
}

export default AssignUserList;

